import { Button, Upload } from 'antd';
import { defaultStyles, FileIcon } from 'react-file-icon';
import { GoTrash } from 'react-icons/go';
import { IoAddOutline } from 'react-icons/io5';
import { extractOriginalFileName, getNewFileName } from '../../helper';

const UploadAttachment = ({ fileList, onChange, readOnly }) => {
    const handlePreview = (file) => {
        const url = file.url || file.thumbUrl || (file.originFileObj && URL.createObjectURL(file.originFileObj));
        window.open(url, '_blank');
    };

    const handleChange = ({ fileList: newFileList }) => {
        const updatedFileList = newFileList.map((file) => {
            if (!file.payload) {
                const uniqueName = getNewFileName(file?.name);
                const thumbUrl =
                    file.thumbUrl || (file.originFileObj ? URL.createObjectURL(file.originFileObj) : '');

                return {
                    ...file,
                    name: uniqueName,
                    thumbUrl,
                    payload: {
                        ContentType: file?.type,
                        display_name: uniqueName,
                        file: file?.originFileObj,
                    },
                };
            }
            return file;
        });

        onChange(updatedFileList);
    };


    const itemRender = (originNode, file, fileList, { remove }) => {
        const ext = file?.name?.split('.').pop()?.toLowerCase();
        const style = defaultStyles[ext] || {};

        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 14px',
                    background: '#ffffff',
                    border: '1px solid #f0f0f0',
                    borderRadius: '10px',
                    marginBottom: '10px',
                    gap: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1)',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
                }}
                className="custom-file-item"
                onClick={() => handlePreview(file)}
            >
                <div style={{ width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa', borderRadius: '6px', overflow: 'hidden' }}>
                    {file.thumbUrl || (file.url && (ext === 'png' || ext === 'jpg' || ext === 'jpeg')) ? (
                        <img src={file.url || file.thumbUrl} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt={file.name} />
                    ) : (
                        <div style={{ width: 24 }}>
                            <FileIcon extension={ext} {...style} />
                        </div>
                    )}
                </div>

                <div style={{ flex: 1, overflow: 'hidden' }}>
                    <div style={{
                        fontWeight: 500,
                        fontSize: '14px',
                        color: '#262626',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}>
                        {extractOriginalFileName(file.name)}
                    </div>
                </div>

                {!readOnly && (
                    <Button
                        type="text"
                        danger
                        icon={<GoTrash />}
                        onClick={(e) => {
                            e.stopPropagation();
                            remove();
                        }}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    />
                )}
            </div>
        );
    };

    return (
        <div className="upload-attachment-wrapper">
            <Upload
                name="file"
                listType="picture"
                beforeUpload={() => false}
                fileList={fileList}
                onChange={handleChange}
                itemRender={itemRender}
                onPreview={handlePreview}
            >
                {!readOnly && (
                    <Button
                        icon={<IoAddOutline style={{ fontSize: '18px' }} />}
                        style={{
                            height: '40px',
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontWeight: 500
                        }}
                    >
                        Add Attachment
                    </Button>
                )}
            </Upload>
            <style dangerouslySetInnerHTML={{
                __html: `
                .custom-file-item:hover {
                    border-color: #1677ff !important;
                    box-shadow: 0 4px 12px rgba(22, 119, 255, 0.08) !important;
                    background: #f0f7ff !important;
                }
            `}} />
        </div>
    );
};

export default UploadAttachment;
